import { Mark, Node, Schema } from 'hubspot-prosemirror/pm/model';
import { EditorState } from 'hubspot-prosemirror/pm/state';
import { MarkBounds } from '../../../types';

export function getLinkText(doc: Node, markBounds: MarkBounds) {
  const { from, to } = markBounds;
  return doc.textBetween(from, to);
}

export function getLinkAttrs(state: EditorState, markBounds: MarkBounds) {
  const { from } = markBounds;
  const node = state.doc.nodeAt(from);
  const linkMark = state.schema.marks.link;
  if (!node) return null;
  const mark = linkMark.isInSet(node.marks);
  return mark ? mark.attrs : null;
}

function checkSelectionInsideLink(state: EditorState) {
  return state.schema.marks.link.isInSet(state.selection.$from.marks());
}

function checkSelectionAroundLink(state: EditorState) {
  const { $from } = state.selection;
  const nodeAfter = $from.nodeAfter;
  const nodeBefore = $from.nodeBefore;
  let marks = nodeAfter ? nodeAfter.marks : [];
  marks = nodeBefore ? marks.concat(nodeBefore.marks) : marks;
  if ($from.textOffset === 0) {
    return state.schema.marks.link.isInSet(marks);
  }
  return undefined;
}

export function getActiveLinkMark(state: EditorState) {
  return checkSelectionInsideLink(state) || checkSelectionAroundLink(state);
}

export type InlineVideoAttrs = {
  url: string;
  base_url: string;
  videoTitle: string;
};

export function makeInlineVidyardVideoNode(
  schema: Schema,
  attrs: InlineVideoAttrs
) {
  return schema.nodes.inlineVidyardVideo.create(attrs);
}

export function makeLinkNode(
  schema: Schema,
  href: string,
  linkText: string,
  isTargetBlank: boolean,
  noFollow: boolean,
  extraMarks: readonly Mark[] = []
) {
  return schema.text(
    linkText,
    schema.marks.link
      .create({
        href,
        title: linkText,
        isTargetBlank,
        rel: noFollow ? 'nofollow' : undefined,
      })
      .addToSet(extraMarks)
  );
}
